<template>
  <footer class="footer">
    <div class="footer__inner">
      <div class="footer__progress">
        <BaseProgress :percent="progress" />
      </div>
      <div class="footer__actions">
        <BaseButton
          v-if="isPrevButtonVisible"
          class="footer__action footer__action_prev"
          is-dim
          @click="goPrev"
        >
          <BaseIcon name="arrow_left" class="button__icon" />
          <span v-if="prevButtonText" v-text="prevButtonText" />
        </BaseButton>
        <BaseButton
          v-if="isNextButtonVisible"
          class="footer__action footer__action_next"
          is-bright
          @click="goNext"
        >
          <span v-if="nextButtonText" v-text="nextButtonText" />
          <BaseIcon name="arrow_right" class="button__icon button__icon_after" />
        </BaseButton>
      </div>
    </div>
<!--     <div class="footer__inner">
      <div v-if="!isIntroPage" class="footer__corner footer__corner_left">
        <BaseHint v-if="isHintsVisible" class="footer__hint" data-animation="hint" data-animation-delay="7000">
          Нажмите на кнопку <b>«Назад»</b>, чтобы перейти на предыдущий слайд
        </BaseHint>
        <button
          class="footer__button footer__button_back"
          type="button"
          @click="$emit('click:back')"
        >
          <BaseIcon name="arrow" class="footer__arrow" />
        </button>
      </div>
      <div class="footer__corner footer__corner_right">
        <BaseHint v-if="isHintsVisible" class="footer__hint" data-animation="hint" data-animation-delay="10000">
          Нажмите на кнопку <b>«Далее»</b>, чтобы перейти на следующий слайд
        </BaseHint>
        <button
          class="footer__button"
          type="button"
          data-animation="fadeIn"
          data-animation-delay="1200"
          @click="$emit('click:next')"
        >
          <span v-if="nextButtonText" v-text="nextButtonText" />
          <BaseIcon name="arrow" class="footer__arrow" />
        </button>
      </div>
    </div> -->
  </footer>
</template>

<script>
import { mapState } from 'vuex';
import { ACTION_NAMES } from '@/App.vue';

import BaseIcon from '@/components/BaseIcon.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseProgress from '@/components/BaseProgress.vue';
// import BaseHint from '@/components/BaseHint.vue';
// import { paths } from '@/router/index';

export default {
  name: 'TheFooter',
  components: {
    BaseIcon,
    BaseButton,
    BaseProgress,
    // BaseHint,
  },
  // props: {
  //   isHintsVisible: {
  //     type: Boolean,
  //     default: false,
  //   },
  // },
  computed: {
    ...mapState(['progress']),
    isPrevButtonVisible() {
      return Boolean(this.$route.meta && this.$route.meta.prev);
    },
    isNextButtonVisible() {
      return Boolean(this.$route.meta && this.$route.meta.next);
    },
    prevButtonText() {
      const { prevButtonText = 'Назад' } = this.$route.meta || {};
      return prevButtonText;
    },
    nextButtonText() {
      const { nextButtonText = 'Далее' } = this.$route.meta || {};
      return nextButtonText;
    },
    // isIntroPage() {
    //   return this.$route.path === paths.intro;
    // },
    // isFinalPage() {
    //   return this.$route.path === paths.final;
    // },
    // nextButtonText() {
    //   if (this.isFinalPage) return 'Завершить';
    //   if (this.isIntroPage) return 'Начать';
    //   return '';
    // },
  },
  methods: {
    goPrev() {
      this.$root.$emit(ACTION_NAMES.PREV);
    },
    goNext() {
      this.$root.$emit(ACTION_NAMES.NEXT);
    },
  },
};
</script>

<style lang="stylus">
.footer
  display block
  +portrait()
    padding 1.25em 0
    background-color #fff
    background linear-gradient(180deg, alpha(@background-color, 0%), @background-color 50%)
    // @supports (backdrop-filter: blur(10px))
    //   background-color alpha(#fff, 35%)
    //   backdrop-filter: blur(10px)
    // background-color #fff
    // box-shadow 0 -0.25em 1em rgba(0, 0, 0, 0.15)
    // border-radius 1.25em 1.25em 0 0
  +landscape()
    background-color #fff
    box-shadow 0 0 2em rgba(0, 0, 0, 0.07)
    padding 1.12em 0//2em
    // @supports (backdrop-filter: blur(10px))
    //   background-color alpha(#fff, 95%)
    //   backdrop-filter: blur(10px)

  &__inner
    padding-left 1.4em
    padding-right @padding-left
    +landscape()
      display flex
      align-items center
      padding-left 2em
      padding-right @padding-left

  &__progress
    display none
    +landscape()
      display block
      flex-grow 1
      flex-basis 0
      max-width calc(100% - 18em)
      padding-right 4em

  &__actions
    display flex
    +landscape()
      width 18em
    //justify-content space-between
    // padding-bottom 2em

  &__action
    &_next
      &.button
        margin-left auto
    &_prev
      &.button
        margin-right auto
    &.button
      flex 0 0 50%
      max-width 48%
      padding 0

  // &__inner
  //   display flex

  // &__corner
  //   position relative
  //   transition transform 200ms cubic-bezier(0.85, 0, 0.15, 1)
  //   &_left
  //     .section-slide-leave-active ~ .footer &
  //       transform translate(-110%, 0)
  //   &_right
  //     margin-left auto
  //     .section-slide-leave-active ~ .footer &
  //       transform translate(110%, 0)
  //   +portrait()
  //     flex 0 0 50%
  //     max-width 50%

  // &__hint
  //   abs bottom 100%
  //   width 18em
  //   max-width calc(100vw - 3em)
  //   margin 1.2em 0
  //   pointer-events none
  //   ~/__corner_left &
  //     left 100%
  //     +portrait()
  //       left 0
  //       margin 1.2em
  //   ~/__corner_right &
  //     right 100%
  //     +portrait()
  //       right 0
  //       margin 1.2em

  // &__button
  //   display flex
  //   justify-content center
  //   align-items center
  //   font-size 1.25em
  //   font-weight 700
  //   color #fff
  //   background-color $c_bright
  //   height 4em
  //   min-width @height
  //   outline none
  //   padding 0 1.5em
  //   pointer-events auto
  //   margin 0
  //   border 0
  //   &:focus
  //   &:hover
  //     background-color darken(@background-color, 10%)
  //   +portrait()
  //     width 100%
  //     height 60px
  //   &_back
  //     background-color #d2d2d2
  //     &:focus
  //     &:hover
  //       background-color darken(@background-color, 10%)
  //   span
  //     .section-slide-leave-active ~ .footer &
  //       display none

  // &__arrow
  //   margin-left 0.6em
  //   width 0.784em
  //   height @width
  //   &:first-child
  //     margin-left 0
  //   ~/__button_back &
  //     transform rotate(180deg)
</style>
